import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=36639212&scoped=true"
import script from "./loading.vue?vue&type=script&lang=ts"
export * from "./loading.vue?vue&type=script&lang=ts"
import style0 from "./loading.vue?vue&type=style&index=0&id=36639212&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36639212",
  null
  
)

export default component.exports